import { NPSModalAction, NpsInitialStateType } from "./nps-reducer.types";
export const npsReducer = (
  state: NpsInitialStateType,
  action: NPSModalAction
): NpsInitialStateType => {
  switch (action.type) {
    case "SUBMIT_NPS_FEEDBACK":
      return {
        ...state,
        rating: action.payload.scale,
        feedbackId: action.payload.feedbackId
      };

    case "SUBMIT_FEEDBACK_EXPLANATION_FORM":
      return {
        ...state,
        isFeedbackFormSubmitted: true
      };

    case "SUBMIT_PARENT_NUMBER_FORM": {
      return { ...state, isParentFormSubmitted: true };
    }

    case "TOGGLE_SKIP_CONFIRMATION": {
      return { ...state, showSkipConfirmation: action.payload };
    }
    case "CLOSE_NPS_MODAL": {
      return { ...action.payload };
    }

    default:
      return state;
  }
};

export const npsInitialState = {
  rating: null,
  isFeedbackFormSubmitted: false,
  isParentFormSubmitted: false,
  showSkipConfirmation: false,
  liveClassId: "",
  feedbackId: ""
};
